<template>
  <div>
    <px-view-header title="Dicionário de dados" :breadcrumbs="breadcrumbs"/>

    <px-dicionario-dados-header
      @indexar="indexar"
      @refresh="refresh"
      @change="onChangeFilter"/>
    <px-dicionario-dados-list
      @update="refresh"
      :dicionarios="dicionarioDados"
      :loading="loading"
      @change="onChangeOptions"
      :options-list="optionsList"
    />
  </div>
</template>

<script>
import paginationMixin from '@/mixins/pagination-mixin';
import DicionarioDadosService from './dicionario-dados-service';
import DicionarioDadosHeader from './DicionarioDadosHeader.vue';
import DicionarioDadosList from './DicionarioDadosList.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      breadcrumbs: [
        { text: 'Marketplace' },
        { text: 'Dicionario de dados' },
      ],
      searchText: null,
      dicionarioDados: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 25,
        offset: 0,
        filter: '',
        sort: 'word',
      },
      loading: false,
      optionsList: {},
    };
  },
  methods: {
    indexar() {
      DicionarioDadosService.indexar()
        .then(() => {
          this.$toast('Dicionário atualizado', { color: 'success' });
        });
    },
    refresh() {
      this.getDicionarioDados();
    },
    onChangeFilter(filter) {
      this.listOptions.filter = filter;
      this.resetPage();
      this.getDicionarioDados();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getDicionarioDados();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getDicionarioDados() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return DicionarioDadosService.list({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.dicionarioDados = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxDicionarioDadosHeader: DicionarioDadosHeader,
    pxDicionarioDadosList: DicionarioDadosList,
  },
};
</script>
